module.exports = __webpack_public_path__ + "img/头图_人工智能在数据治理应用的思考.de76f3fa.png";